export default __webpack_public_path__ + "static/media/crypto.7ae8fcc1.svg";